import axios from "axios";

export const USER_GROUP_AUTHORITY_URL = "/UserGroupAuthority";

// Mevcut Okulun Aktif Kullanıcı Grubu, Modül ve Yetki Listesini Elde Eder
export function getList() {
  return axios.get(USER_GROUP_AUTHORITY_URL);
}

// Belli Bir Kullanıcı Grubunun Yetkilerini Elde Eder
export function getAuthorities(userGroupId) {
  return axios.get(`${USER_GROUP_AUTHORITY_URL}/${userGroupId}`);
}

// Belli Bir Kullanıcı Grubunun Yetkilerini Kaydeder
export function saveAuthorities(userGroupId, moduleAndAuthorities) {
  return axios.post(USER_GROUP_AUTHORITY_URL, { userGroupId, moduleAndAuthorities });
}